<template>
  <div class="disable-monitoring-container">
    <div class="title">{{ $t('cautionDisablePackage') }}</div>
    <!-- <div class="content">{{$t('disablePackageInfos')}}</div> -->
    <div class="choices">
      <div class="cancel main-button" @click.stop="popupResolve(false)">{{ $t('cancel') }}</div>
      <div class="submit main-button" @click.stop="popupResolve(true)">{{ $t('Disable') }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['popupResolve', 'popupReject']),
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
* {
  box-sizing: border-box;
}

.disable-monitoring-container {
  width: 600px;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;

  .title {
    color: colors.$darkblue-color;
    font-size: 22px;
    font-weight: 500;
  }

  .content {
    color: colors.$darkgrey-color;
    font-size: 14px;
    opacity: 0.8;
    margin: 16px 0;
  }

  .choices {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .main-button {
      margin: 8px 12px 0;
      width: 164px;
      padding: 0;
    }

    .cancel {
      margin: 0 12px 0 0;
      background: colors.$lightgrey-color;
      color: colors.$darkgrey-color;
    }
  }
}
</style>
